var map = {
	"./SingleSource_logo_blue rectangle.svg": 858,
	"./SingleSource_logo_dark.png": 859,
	"./SingleSource_logo_light.png": 860,
	"./SingleSource_logo_transparent rectangle.svg": 861,
	"./default-church-logo.png": 277,
	"./favicon.ico": 862,
	"./logo-danger.png": 863,
	"./logo-dark.png": 864,
	"./logo-info.png": 865,
	"./logo-primary.png": 866,
	"./logo-success.png": 867,
	"./logo-warning.png": 868,
	"./logo.png": 869,
	"./logo.svg": 870,
	"./sslogo.ico": 871,
	"./sslogo.png": 216,
	"./vuexy-logo.png": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 857;